import { baseAPICreator } from './apiCreator';
import { SearchResultProps, SearchHistoryProps } from 'src/types/search';

const searchApi = baseAPICreator('/search');

export const getSearchResult = async (body: {
  pageSize: number;
  page: number;
  texts: string[];
  mode: string;
  genres: string[];
  publishers: string[];
  shows?: string[];
  operator?: string;
  matchType?: string;
  dateRange?: {
    from: string;
    to: string;
  };
}): Promise<{ data: SearchResultProps }> => {
  const { data } = await searchApi.post('', body);
  return { data: data };
};

export const getSearchResultV2 = async (body: {
  pageSize: number;
  page: number;
  texts: string[];
  mode: string;
  showIds?: string[];
  operator?: string;
  matchType?: string;
  dateRange?: {
    from: string;
    to: string;
  };
  dataLevel?: string;
}): Promise<{ data: SearchResultProps }> => {
  const { data } = await searchApi.post('v2', body);
  return { data: data };
};

export const getSearchHistory = async (): Promise<{
  data: SearchHistoryProps[];
}> => {
  const { data } = await searchApi.get('recent');
  return {
    data: data.map((item: any) => ({
      ...item,
      query: item.query,
      date: item.createdAt,
    })),
  };
};
